import { registerThemeSpec } from '@xhs/yam-beer/core/system/utils/themeSpec'

export default function initStyle() {
  return [
    registerThemeSpec('cmp.select.cascade', {
      box: {
        height: '100%',
        overflow: 'auto',
        border: '1px solid #d9d9d9',
        borderRadius: 'control',
        minWidth: 172,
        maxWidth: 300,
      },
      split: {
        width: 30,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      empty: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 26,
        height: '100%',
        color: 'mute',
      },
    }),
  ]
}
